var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "comment-replies__list" },
      _vm._l(_vm.slicePartOfComments, function(comment) {
        return _c("RootComment", {
          key: comment.id,
          attrs: { comment: comment }
        })
      }),
      1
    ),
    _vm._v(" "),
    _vm.hasMoreComments
      ? _c(
          "button",
          {
            staticClass: "comment-replies__show-more-btn",
            on: { click: _vm.showNextComments }
          },
          [_vm._v(_vm._s(_vm.btnText) + "\n    ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }